import { Validators } from '@angular/forms';
import { TableCols } from '../interfaces/static-data';

export enum DeskType {
  LEGAL = 'LEGAL',
  OPERATIONS = 'OPERATIONS',
  SALES = 'SALES',
  STRUCTURING = 'STRUCTURING',
  TRADING = 'TRADING',
  TRADE_SUPPORT = 'TRADE_SUPPORT',
}

export const DESK_TYPE_ITEMS = [
  { id: DeskType.LEGAL, displayValue: 'Legal' },
  { id: DeskType.OPERATIONS, displayValue: 'Operations' },
  { id: DeskType.SALES, displayValue: 'Sales' },
  { id: DeskType.STRUCTURING, displayValue: 'Structuring' },
  { id: DeskType.TRADING, displayValue: 'Trading' },
  { id: DeskType.TRADE_SUPPORT, displayValue: 'Trade Support' },
];

export const DESKS: TableCols[] = [
  {
    key: 'issuerId',
    displayValue: 'Issuer Entity',
    type: 'select',
    validators: [Validators.required],
  },
  {
    key: 'deskType',
    displayValue: 'Desk Type',
    validators: [Validators.required],
    type: 'select',
    items: DESK_TYPE_ITEMS
  },
  {
    key: 'tenantId',
    displayValue: 'Tenant',
    validators: [Validators.required],
    type: 'select',
    items: []
  },
  {
    key: 'name',
    displayValue: 'Desk Name',
    validators: [Validators.required],
  },
  {
    key: 'email',
    displayValue: 'Contact Emails',
    validators: [Validators.required],
    type: 'tag',
    placeholder: 'Add emails separated by semicolon...',
    customErrorMessage: 'Invalid e-mail address',
    validateRegex: '\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*'
  },
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];
